import { useEffect } from 'react';

export default (shouldRedirect, redirectUrl, timeout = 0) =>
  useEffect(() => {
    if (shouldRedirect) {
      if (timeout !== 0) {
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, timeout);
      } else {
        window.location.href = redirectUrl;
      }
    }
  }, [shouldRedirect, redirectUrl, timeout]);
